import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "railway-auth__bg-grid" }, null, -1)
const _hoisted_3 = {
  class: "railway-auth__hero",
  ref: "heroPanel"
}
const _hoisted_4 = { class: "railway-auth__hero-content" }
const _hoisted_5 = {
  class: "railway-auth__badge",
  ref: "heroBadge"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "railway-auth__badge-dot" }, null, -1)
const _hoisted_7 = {
  class: "railway-auth__title",
  ref: "heroTitle"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Vật tư", -1)
const _hoisted_9 = {
  class: "railway-auth__subtitle",
  ref: "heroSubtitle"
}
const _hoisted_10 = { class: "railway-auth__features" }
const _hoisted_11 = { class: "railway-auth__feature-icon" }
const _hoisted_12 = { class: "railway-auth__feature-text" }
const _hoisted_13 = { class: "railway-auth__scene" }
const _hoisted_14 = { class: "railway-auth__tracks" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "railway-auth__track-rail railway-auth__track-rail--top" }, null, -1)
const _hoisted_16 = {
  class: "railway-auth__track-ties",
  ref: "trackTies"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "railway-auth__track-rail railway-auth__track-rail--bottom" }, null, -1)
const _hoisted_18 = {
  class: "railway-auth__train",
  ref: "trainEl"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<svg class=\"railway-auth__train-car\" width=\"90\" height=\"52\" viewBox=\"0 0 90 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"18\" width=\"82\" height=\"28\" rx=\"4\" fill=\"#1B4F8A\"></rect><rect x=\"8\" y=\"22\" width=\"30\" height=\"14\" rx=\"2\" fill=\"#E8A317\" opacity=\"0.8\"></rect><rect x=\"42\" y=\"22\" width=\"18\" height=\"14\" rx=\"2\" fill=\"#2A6CB8\" opacity=\"0.6\"></rect><rect x=\"64\" y=\"22\" width=\"18\" height=\"14\" rx=\"2\" fill=\"#2A6CB8\" opacity=\"0.6\"></rect><circle cx=\"22\" cy=\"46\" r=\"6\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"2\"></circle><circle cx=\"68\" cy=\"46\" r=\"6\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"2\"></circle><rect x=\"0\" y=\"8\" width=\"20\" height=\"22\" rx=\"3\" fill=\"#E8A317\"></rect><rect x=\"4\" y=\"12\" width=\"8\" height=\"8\" rx=\"1\" fill=\"#FFF8E7\" opacity=\"0.7\"></rect><rect x=\"70\" y=\"4\" width=\"4\" height=\"16\" rx=\"1\" fill=\"#94A3B8\"></rect><circle cx=\"72\" cy=\"2\" r=\"3\" fill=\"#F5C842\" opacity=\"0.6\"></circle></svg><svg class=\"railway-auth__train-car\" width=\"60\" height=\"44\" viewBox=\"0 0 60 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"14\" width=\"56\" height=\"24\" rx=\"3\" fill=\"#2A6CB8\"></rect><rect x=\"6\" y=\"18\" width=\"20\" height=\"12\" rx=\"2\" fill=\"#415A77\" opacity=\"0.5\"></rect><rect x=\"30\" y=\"18\" width=\"20\" height=\"12\" rx=\"2\" fill=\"#415A77\" opacity=\"0.5\"></rect><circle cx=\"18\" cy=\"38\" r=\"5\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"1.5\"></circle><circle cx=\"44\" cy=\"38\" r=\"5\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"1.5\"></circle></svg><svg class=\"railway-auth__train-car\" width=\"60\" height=\"44\" viewBox=\"0 0 60 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"14\" width=\"56\" height=\"24\" rx=\"3\" fill=\"#1B4F8A\" opacity=\"0.85\"></rect><rect x=\"6\" y=\"18\" width=\"48\" height=\"12\" rx=\"2\" fill=\"#E8A317\" opacity=\"0.3\"></rect><circle cx=\"18\" cy=\"38\" r=\"5\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"1.5\"></circle><circle cx=\"44\" cy=\"38\" r=\"5\" fill=\"#2D3748\" stroke=\"#94A3B8\" stroke-width=\"1.5\"></circle></svg>", 3)
const _hoisted_22 = [
  _hoisted_19
]
const _hoisted_23 = { class: "railway-auth__float-icons" }
const _hoisted_24 = {
  class: "railway-auth__float-icon railway-auth__float-icon--1",
  ref: "floatIcon1"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-seam" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "railway-auth__float-icon railway-auth__float-icon--2",
  ref: "floatIcon2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wrench-adjustable" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  class: "railway-auth__float-icon railway-auth__float-icon--3",
  ref: "floatIcon3"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard-data" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  class: "railway-auth__form-wrapper",
  ref: "formWrapper"
}
const _hoisted_34 = { class: "railway-auth__logo" }
const _hoisted_35 = {
  href: "https://www.vantaiduongsathanoi.vn/",
  target: "_blank"
}
const _hoisted_36 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["railway-auth", _ctx.loginStateClass]),
      id: "kt_login"
    }, [
      _hoisted_2,
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" Hệ thống quản lý đường sắt ")
          ], 512),
          _createElementVNode("h1", _hoisted_7, [
            _createTextVNode(" Quản lý "),
            _hoisted_8,
            _createTextVNode(" & Sửa chữa Toa xe ")
          ], 512),
          _createElementVNode("p", _hoisted_9, " Nền tảng tích hợp quản lý kho, tồn kho phụ tùng và kế hoạch bảo dưỡng toa xe — vận hành hiệu quả, minh bạch. ", 512),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: feature.title,
                class: "railway-auth__feature",
                ref_for: true,
                ref: (el) => _ctx.setFeatureRef(el, index)
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("i", {
                    class: _normalizeClass(feature.icon)
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(feature.title), 1),
                  _createElementVNode("span", null, _toDisplayString(feature.desc), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(40, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "railway-auth__track-tie"
                })
              }), 64))
            ], 512),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, _hoisted_22, 512)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _hoisted_26, 512),
          _createElementVNode("div", _hoisted_27, _hoisted_29, 512),
          _createElementVNode("div", _hoisted_30, _hoisted_32, 512)
        ])
      ], 512),
      _createElementVNode("main", {
        class: "railway-auth__main bgi-size-cover bgi-position-top bgi-no-repeat",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImage})` })
      }, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("a", _hoisted_35, [
              _createElementVNode("img", {
                src: _ctx.logoPath,
                alt: "Logo"
              }, null, 8, _hoisted_36)
            ])
          ]),
          _createVNode(_component_router_view)
        ], 512)
      ], 4)
    ], 2)
  ]))
}